const features = [
  {
    icon: 'ri-radar-line',
    title: '全网信源覆盖',
    desc: '接入微博、豆瓣、抖音、小红书等主流平台实时热点，黑料吃瓜不遗漏任何一个角落。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速实时更新',
    desc: '热门爆料事件发生30分钟内即收录，全年365天无休，保持黑料每日最新鲜度。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多方信息交叉验证',
    desc: '同一事件聚合多平台信源，帮助吃瓜群众辨别真伪，不做盲目跟风的吃瓜人。',
  },
  {
    icon: 'ri-layout-grid-line',
    title: '结构化分类索引',
    desc: '按明星、综艺、网红、社会等维度精细分类，快速定位你关注的爆料领域。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端适配浏览',
    desc: 'PC端、移动端完美适配，蹲坑摸鱼随时随地打开手机就能追最新瓜。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          为什么每日黑料网是全网最好的黑料吃瓜导航？五个理由告诉你
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 text-center hover:border-primary-200 transition-colors group cursor-default"
            >
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}